import React from 'react';
import {
  AgreementsReadyCard,
  AgreementsWaitingCard,
} from '../../components/AgreementsCard';
import { SigningDocumentCover } from 'src/components/Cover';
import { CoverWrapper } from 'src/components/Cover/styles.ts';

export const ForSigning = () => {
  return (
    <>
      <CoverWrapper>
        <SigningDocumentCover />
      </CoverWrapper>
      <AgreementsReadyCard />
      <AgreementsWaitingCard />
    </>
  );
};
